import PageHeader from "@/components/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { AgreementCreatorForm } from "./AgreementCreatorForm";
import { useAgreementBreadcrumbs } from "../hooks";

const AgreementCreator = () => {
  const { t } = useTranslation();
  const { breadcrumbItems } = useAgreementBreadcrumbs();

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <Card>
        <CardHeader>
          <CardTitle>{t("agreements.createForm.title")}</CardTitle>
        </CardHeader>
        <CardContent>
          <AgreementCreatorForm />
        </CardContent>
      </Card>
    </>
  );
};

export default AgreementCreator;
